<template>
    <div class="container">
        <back-button location="/technologies"></back-button>

        <h1 class="title">Mobile</h1>
        <div class="logo swing-animation">
            <img src="../../assets/images/Mobile.svg"/>
        </div>
        <div class="content">
            <div class="mobile-version-chart">
                <div class="chart-group">
                    <p class="chart-sub-title">Frameworks and approaches for developing mobile applications</p>
                    <apex-charts type="bar" :options="platformOptions" :series="platformSeries" height="250"
                                 class="chart"></apex-charts>
                </div>
                <p class="fun-fact">86% of mobile applications are designed to work on phones and 54% are designed to work on tablets</p>
            </div>
            <div class="mobile-module-chart">
                <div class="chart-group">
                    <p class="chart-sub-title">Purpose and availability of mobile apps developed by Entelectuals</p>
                    <apex-charts type="donut" :options="availabilityOptions" :series="availabilitySeries"
                                 class="chart"></apex-charts>
                </div>
            </div>
            <div class="mobile-serve-chart">
                <div class="chart-group">
                    <p class="chart-sub-title">90% of apps developed by Entelectuals are free to use</p>
                    <apex-charts type="bar" :options="moduleOptions" :series="moduleSeries" class="chart"></apex-charts>
                </div>
                <p class="fun-fact">Push notifications, background tasks, Gyroscope, and Camera are the most used mobile features</p>
            </div>
            <div class="mobile-build-chart">
                <div class="chart-group">
                    <p class="chart-sub-title">Breakdown of what devices are planned for when creating a mobile application</p>
                    <apex-charts type="bar" :options="serveOptions" :series="serveSeries" height="400px"
                                 class="chart"></apex-charts>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import VueApexCharts from "vue-apexcharts/src";
    import BackButton from "../../widgets/BackButton";

    export default {
        components: {
            'apex-charts': VueApexCharts,
            BackButton
        },
        data: function () {
            return {
                platformOptions: {
                    chart: {
                        toolbar: {
                            show: false
                        }
                    },
                    colors: ['#8EC63F', '#008AD0', '#B51E8E', '#D8181F', '#00994C', '#009EA5', '#F7941D'],
                    labels: ['Cordova', 'Xamarin', 'Native iOS', 'Native Android & iOS', 'React Native', 'Native Android'],
                    plotOptions: {
                        bar: {
                            columnWidth: '45%',
                            distributed: true,
                            horizontal: true
                        }
                    },
                    dataLabels: {
                        enabled: false,
                    },
                    yaxis: {
                        categories: ['Cordova', 'Xamarin', 'Native iOS', 'Native Android & iOS', 'React Native', 'Native Android'],
                        labels: {
                            style: {
                                colors: ['#fff', '#fff', '#fff', '#fff', '#fff', '#fff', '#fff'],
                                fontSize: '14px'
                            }
                        }
                    },
                    xaxis: {
                        labels: {
                            style: {
                                colors: '#FFF',
                            },
                        }
                    },
                    tooltip: {
                        theme: 'dark',
                        y: {
                            formatter: (value) => `${value}%`
                        },
                        marker: {
                            show: true
                        }
                    },
                },
                platformSeries: [{
                    name: 'Usage',
                    data: [4.2, 4.2, 8.3, 12.5, 16.7, 54.2]
                }],
                availabilityOptions: {
                    chart: {
                        toolbar: {
                            show: false
                        }
                    },
                    legend: {
                        labels: {
                            color: '#FFF'
                        },
                        position: 'bottom',
                    },
                    colors: ['#F7941D', '#008AD0', '#B51E8E', '#009EA5'],
                    labels: ['Public', 'Internal', 'Public & Internal', 'Personal'],
                    tooltip: {
                        enabled: true,
                        y: {
                            formatter: (value) => `${value}%`
                        }
                    },
                    stroke: {
                        width: 0
                    },
                    fill: {
                        patern: {
                            width: 500
                        }
                    },
                    dataLabels: {
                        formatter: function (val, opt) {
                            if (val < 5)
                                return '';
                            if (val < 10)
                                return `${Math.round(val)}%`;
                            return `${opt.w.globals.labels[opt.seriesIndex]}: ${Math.round(val)}%`;
                        },
                    },
                    plotOptions: {
                        pie: {
                            donut: {
                                size: '50%',
                            },
                        }
                    },
                    responsive: [{
                        breakpoint: 599,
                        options: {
                            dataLabels: {
                                formatter: function (val) {
                                    if (val < 5)
                                        return '';
                                    return `${Math.round(val)}%`;
                                },
                            },
                        }
                    }]
                },
                availabilitySeries: [70.8, 12.5, 8.3, 8.3],
                moduleOptions: {
                    chart: {
                        stacked: true,
                        stackType: '100%',
                        toolbar: {
                            show: false
                        }
                    },
                    dataLabels: {
                        formatter: (val) => {
                            if (val < 15) {
                                return '';
                            }

                            return `${Math.round(val)}%`;
                        }
                    },
                    colors: ['#B51E8E', '#009EA5', '#008AD0', '#F7941D', '#00994C'],
                    plotOptions: {
                        bar: {
                            horizontal: true,
                        }
                    },
                    legend: {
                        position: 'top',
                        labels: {
                            color: '#FFF'
                        }
                    },
                    yaxis: {
                        show: false,
                        labels: {
                            show: false,
                            style: {
                                color: '#FFF',
                            },
                        },
                    },
                    xaxis: {
                        labels: {
                            style: {
                                colors: '#FFF',
                            },
                        },
                        categories: ['App Cost']
                    },
                    tooltip: {
                        theme: 'dark',
                        y: {
                            formatter: (value) => `${value}%`
                        }
                    },
                },
                moduleSeries: [{
                    name: 'Free Apps',
                    data: [89.6]
                }, {
                    name: 'Paid Apps',
                    data: [10.4]
                }],
                serveOptions: {
                    chart: {
                        toolbar: {
                            show: false
                        }
                    },
                    colors: ['#B51E8E', '#009EA5', '#F7941D', '#008AD0', '#00994C'],
                    labels: ['Phones and Tablets', 'Phones', 'Tablets', 'Watches'],
                    plotOptions: {
                        bar: {
                            columnWidth: '45%',
                            distributed: true
                        }
                    },
                    dataLabels: {
                        enabled: false,
                    },
                    yaxis: {
                        labels: {
                            style: {
                                color: '#FFF',
                            },
                        }
                    },
                    xaxis: {
                        categories: ['Phones', 'Tablets', 'Watches', 'All devices'],
                        labels: {
                            style: {
                                colors: '#fff',
                                fontSize: '14px'
                            }
                        }
                    },
                    tooltip: {
                        theme: 'dark',
                        y: {
                            formatter: (value) => `${value}%`
                        },
                        marker: {
                            show: true
                        }
                    },
                },
                serveSeries: [{
                    name: 'Amount',
                    data: [85.4, 54.2, 2.1, 4.2]
                }],
            }
        },
        methods: {
            track () {
                this.$ga.page('/2018/technology/mobile') // This is for Google Analytics tracking
            }
        }
    }
</script>

<style lang="scss" scoped>
    .container {
        display: grid;
        grid-template-columns: 1fr 600px 1fr;
        grid-template-rows: auto 1fr;
        grid-template-areas: 'back title   logo' 'content content content';
        color: white;
        text-align: center;
        background-size: cover;
        background-position: center;
        padding-bottom: 48px;

        @media only screen and (max-width: $screen-sm-max) {
            grid-template-columns: 1fr 2fr 1fr;
        }

        .logo {
            grid-area: logo;
            height: 160px;
            width: 160px;
            align-self: start;
            justify-self: end;
            background: $green;
            border-bottom-left-radius: 100%;
            display: grid;

            @media only screen and (max-width: $screen-xs-max) {
                display: none;
            }

            img {
                width: 50%;
                height: 50%;
                align-self: start;
                justify-self: end;
                margin: 20px;
            }
        }

        .title {
            grid-area: title;
            align-self: center;
            justify-self: center;
            align-content: center;
            justify-content: center;
            margin: 24px;
            display: grid;
        }

        .content {
            grid-area: content;
            display: grid;
            grid-template-areas: '. version module .' '. serve build .';
            grid-template-columns: 1fr 1fr 1fr 1fr;
            grid-template-rows: auto auto;

            @media only screen and (max-width: $screen-sm-max) {
                grid-template-areas: '. version .' '. module .' '. serve .' '. build .';
                grid-template-columns: 1fr 2fr 1fr;
            }

            .fun-fact {
                align-self: center;
                justify-self: center;
                margin: 24px;
            }

            .chart {
                width: 360px;
                align-self: center;
                justify-self: center;

                @media only screen and (max-width: $screen-xs-max) {
                    width: 250px;
                }
            }

            .chart-group {
                border-left: 2px solid $entelect-orange;
                padding-left: 24px;
                margin-bottom: 24px;
                display: grid;
            }

            .chart-title {
                align-self: start;
                justify-self: start;
            }

            .chart-sub-title {
                align-self: start;
                justify-self: start;
                text-align: left;
                margin-bottom: 24px;
            }

            .mobile-version-chart {
                grid-area: version;
                display: grid;

                .chart-sub-title {
                    width: 250px;
                }
            }

            .mobile-serve-chart {
                grid-area: serve;
                display: grid;
                padding-top: 24px;

                .chart-sub-title {
                    width: 250px;
                }
            }

            .mobile-module-chart {
                grid-area: module;
                display: grid;

                .chart-sub-title {
                    width: 250px;
                }
            }

            .mobile-build-chart {
                grid-area: build;
                display: grid;

                .chart-sub-title {
                    width: 250px;
                    margin: 0;
                }
            }
        }
    }
</style>
